import styled from "styled-components";

export const ModalContainer = styled.div`
  display: flex;
  max-width: 460px;
  width: 100%;
  padding: 16px;
  flex-direction: column;
  gap: 16px;
  border-radius: 24px;
  border: 1px solid #18181b;
  background: #0c0c0e;
`;

export const ModalContent = styled.div`
  padding: 32px;
  @media (max-width: 768px) {
    padding: 20px;
  }
`;

export const ModalTitle = styled.h2`
  font-size: 20px;
  font-weight: 700;
  color: #fff;
  font-family: Figtree;
  letter-spacing: -0.3px;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
`;
export const ModalLink = styled.span`
  color: #fff;
  cursor: pointer;
  text-decoration: underline;
  color: #fff;
  font-family: Figtree;
  font-size: 15px;
  font-style: normal;
  opacity: 0.9;
  font-weight: 400;
  line-height: 20px; /* 133.333% */
  transition: all 0.2s ease-in-out;
  &:hover {
    opacity: 0.75;
  }
`;

export const CloseButton = styled.button`
  background: transparent;
  border: none;
  color: white;
  min-width: 44px;
  max-width: 44px;
  min-height: 44px;
  max-height: 44px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.3s ease;
  z-index: 100;
  position: absolute;
  right: 16px;
`;

export const SelectedPlanInfo = styled.div`
  border-radius: 12px;
  background: linear-gradient(0deg, #657890 0%, #486689 100%);
  color: #fff;
  font-family: Figtree;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  height: 46px;
  padding: 12px 24px;
  line-height: normal;
  letter-spacing: -0.09px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const PaymentOptions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Input = styled.input`
  width: 100%;
  padding: 12px;
  border-radius: 12px;
  border: 0.5px solid #3d3d45;
  background: #18181b;
  color: #fff;
  font-size: 16px;
  transition: all 0.3s ease;
  outline: none;
  box-sizing: border-box;
  font-family: Figtree;

  &::placeholder {
    color: rgba(255, 255, 255, 0.4);
  }

  &:focus {
    border-color: #2877d9;
    box-shadow: 0 0 0 3px rgba(161, 161, 161, 0.1);
    background: rgba(255, 255, 255, 0.08);
  }
`;

export const Label = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;
`;

export const LightText = styled.span`
  color: #fff;
  font-family: Figtree;
  opacity: 0.6;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;
`;

export const EmptyDiv = styled.div`
  height: 18px;
`;

export const PaymentOption = styled.div`
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.1);
`;

export const PaymentQuestion = styled.button`
  width: 100%;
  background: none;
  border: none;
  color: ${({ theme }) => (theme === "light" ? "#1a1a1a" : "white")};
  padding: 20px;
  text-align: left;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 16px;
  transition: background 0.3s ease;

  &:hover {
    background: ${({ theme }) =>
      theme === "light" ? "rgba(0, 0, 0, 0.05)" : "rgba(255, 255, 255, 0.05)"};
  }

  span {
    flex: 1;
  }

  svg:last-child {
    flex-shrink: 0;
    opacity: 0.7;
  }

  @media (max-width: 768px) {
    overflow: auto;
    padding: 10px;
  }
`;

export const PaymentIcon = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #2877d9;
  flex-shrink: 0;
`;

export const PaymentAnswer = styled.div`
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-style: normal;
  opacity: 0.9;
  font-weight: 400;
  line-height: 20px; /* 133.333% */
`;

export const PaymentButton = styled.button`
  width: 100%;
  background: linear-gradient(180deg, #4d9dff 0%, #2877d9 100%);
  color: #fff;
  border: none;
  padding: 16px 24px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  margin-top: 20px;
  gap: 5px;
  font-family: Figtree;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px #4d9dff;
  }

  @media (max-width: 768px) {
    padding: 10px 20px;
  }
`;

export const InputWrapper = styled.div`
  position: relative;
  flex-direction: column;
  display: flex;
  gap: 8px;
`;

export const Text = styled.p`
  position: absolute;
  top: 50%;
  left: 16px;
  transform: translateY(-50%);
  color: #fff;
  font-size: 16px;
  padding-bottom: 5px;
`;
